

import {Component, Vue} from 'vue-property-decorator';


/**
 * Renderless component for registering all clicks to the analytics store
 */
@Component({})
export default class ClickListener extends Vue {

    private mounted() {
        window.document.addEventListener('click', this.onClick);
    }

    private beforeDestroy() {
        window.document.removeEventListener('click', this.onClick);
    }

    private onClick(event) {
        this.$store.commit('analytics/registerClick', event);
    }
}
